import UCalgaryLogo from "../../public/ucalgaryLogo.png";
import Circle from "../LogoSVG/Circle";

export const UCalgaryMobile = () => {
  return (
    <div className="mb-[50px]">
      <div className="w-[200px] 2xl:h-14 2xl:w-14 overflow-hidden bg-white rounded p-2 mb-4">
        <img
          src={UCalgaryLogo}
          alt="logo"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="flex flex-col justify-start">
        <p className="mb-1 font-medium text-[18px]">
          University of Calgary | Canada
        </p>
        <div className="flex flex-row mt-2 mb-2">
          <p className="text-gray-4">Master of Science - MS | 2025 - 2027</p>
        </div>

        <div className="flex flex-row items-start mb-2">
          <div className="text-gray-4 ">
            Supervisors:&nbsp;
            <a
              className="text-custom-green"
              href="https://ldklab.github.io"
              target="_blank"
            >
              Prof. Lorenzo De Carli
            </a>{" "}
            and{" "}
            <a
              className="text-custom-green"
              href="https://calgaryish.com/PI/"
              target="_blank"
            >
              Prof. Benjamin Tan
            </a>
          </div>
        </div>

        <div className="flex flex-row items-start mb-2">
          <div className="text-gray-4 ">
            Fully funded MSc position (Sponsor: NSERC/NSF Collaboration)
          </div>
        </div>

        <div className="flex flex-row items-start mb-2">
          <div className="text-gray-4 ">
            Research: LLM Routing for Software Supply Chain Security
          </div>
        </div>
      </div>
    </div>
  );
};
